import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

let apiPath = '';
export default (function (params) {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: apiPath,
    name: 'GET_PRODUCTION_PIECE_MAIN',
    manual: false,
  });
  useEffect(() => {
    if (params) {
      apiPath = '/api/produce/piece/main';
      if (params.start_time && params.end_time)
        apiPath += `?start_time=${params.start_time}&end_time=${params.end_time}`;
      if (params.device_ids) {
        apiPath += `&device_ids=${params.device_ids}`;
      }
      exec(apiPath);
    }
  }, [params]); // eslint-disable-line react-hooks/exhaustive-deps
  return [data || [], isRequestSuccessed];
});
